import { render, staticRenderFns } from "./OqcIqcInput.vue?vue&type=template&id=2e052b74&"
import script from "./OqcIqcInput.vue?vue&type=script&lang=js&"
export * from "./OqcIqcInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports